<template>
  <el-dialog
    :title="$t('deleteMenuCatalog.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center">
      <p>{{ $t('deleteMenuCatalog.confirmDeleteMenuCatalog') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('deleteMenuCatalog.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="deleteMenuCatalog"
      >
        {{ $t('deleteMenuCatalog.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteMenuCatalog } from '@/api/dev/menuCatalogApi'

export default {
  name: 'DeleteMenuCatalog',
  data() {
    return {
      dialogVisible: false,
      deleteMenuCatalogInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteMenuCatalogInfo = { ...row }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteMenuCatalogInfo = {}
    },
    async deleteMenuCatalog() {
      try {
        const res = await deleteMenuCatalog(this.deleteMenuCatalogInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('deleteMenuCatalog.deleteSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>